import { defineStore } from 'pinia'
import {services, getHeader } from '@/assets/js/config.js'
import axios from 'axios'
import { useAuthStore } from './authStore'

export const useCustomerStore = defineStore('customerStore', {
  state:() => ({
    current_customer: null,
    current_commitment: null,
    current_eligibility: null,
    current_eligibility_pl: null,
    loading_dsr: false,
    customer_statuses: [],
    current_customer_logs: [],
    listing_current_page: 1,
    filter_query: {}
  }),
	getters: {
		app_form_esign_link(){
			if(_gHlp.isEmpty(this.current_customer) || _gHlp.isEmpty(this.current_customer.additional_detail) || _gHlp.isEmpty(this.current_customer.additional_detail.esign_application_form_json) || _gHlp.isEmpty(this.current_customer.additional_detail.esign_application_form_json.esign_url) || _gHlp.checkIsDateExpired(this.current_customer.additional_detail.esign_application_form_json.esign_expired)){
				return null;
			}
			return this.current_customer.additional_detail.esign_application_form_json.esign_url
		},
		app_form_esign_down_link(){
			if(_gHlp.isEmpty(this.current_customer) || _gHlp.isEmpty(this.current_customer.additional_detail) || _gHlp.isEmpty(this.current_customer.additional_detail.esign_application_form_json) || _gHlp.isEmpty(this.current_customer.additional_detail.esign_application_form_json.esign_preview_url)){
				return null;
			}
			return this.current_customer.additional_detail.esign_application_form_json.esign_preview_url
		},
		app_form_can_generate(){
			if(_gHlp.isEmpty(this.current_customer) || _gHlp.isEmpty(this.current_customer.additional_detail) || _gHlp.isEmpty(this.current_customer.additional_detail.esign_application_form_json) || _gHlp.isEmpty(this.current_customer.additional_detail.esign_application_form_json.esign_url) || _gHlp.checkIsDateExpired(this.current_customer.additional_detail.esign_application_form_json.esign_expired) || (this.current_customer.additional_detail.esign_application_form_json.esign_status >= 2)){
				return true;
			}
			return false;
		},
		app_form_expired_date(){
			if(_gHlp.isEmpty(this.current_customer) || _gHlp.isEmpty(this.current_customer.additional_detail) || _gHlp.isEmpty(this.current_customer.additional_detail.esign_application_form_json) || _gHlp.checkIsDateExpired(this.current_customer.additional_detail.esign_application_form_json.esign_expired)){
				return "Link Expired";
			}
			return "exp: "+this.current_customer.additional_detail.esign_application_form_json.esign_expired;
		},
	},
    actions : {
        resetCustomerStore(){
            this.current_customer = null
            this.current_commitment = null
            this.current_eligibility = null
        },
        currentPageChanged(page){
            this.listing_current_page = page
        },
        setFilterQuery(queryString){
            this.filter_query = queryString
            this.listing_current_page = 1
        },
        async getCustomerActivityLog(id, date_picked = null){
            try{
                let query = ''
                if(date_picked){
                    query = '?date=' + date_picked
                }
                const res = await axios.get(services.customer + 'customer/' + id + '/activity_logs' + query, { headers: getHeader() })
                this.current_customer_logs = res.data.data
            }catch(e){
                this.current_customer_logs = []
                console.log('Customer Store (getCustomerActivityLog) failed:' + e.response.data.message)
            }
        },
        async getPrevCustomers(contact_no,created_at) {
            try{
                const res = await axios.get(services.customer + 'customers', {
                        params: {
                            contact_no: contact_no,
                            created_at: '0,'+created_at
                        },
                        headers: getHeader()
                    });
                return (!_gHlp.isEmpty(res.data.data) && !_gHlp.isEmpty(res.data.data.data)) ? res.data.data.data : [];
            }catch(e){
                return [];
            }	
        },
        async getCustomer(id){
            try{
                const res = await axios.get(services.customer + 'customers/' + id +'?full=yes', {headers: getHeader()})
                this.current_customer = res.data.data
                // check if customer is joint
                if(this.current_customer.cjp_id){
                    let combined_names = ''
                    this.current_customer.customer_joint_profiles.forEach((item, index, array) => {
                        if (index === 0){  
                            combined_names = item.name
                        }else{
                            combined_names = combined_names+' + '+item.name
                        }
                    });
                    this.current_customer.name = combined_names
                }
								return this.current_customer;
            }catch(e){
                this.current_customer = null
                console.log('Customer Store (getCustomer) failed:' + e.response.data.message)
								return null;
            }
        },
        async getCustomerSimple(id) {
            try {
                const res = await axios.get(services.customer + 'customers/' + id + '?full=simple', { headers: getHeader() });
                this.current_customer = res.data.data;
        
                // check if customer is joint
                if (!_gHlp.isEmpty(this.current_customer.customer_joint_profiles)) {
                    let combined_names = '';
                    this.current_customer.customer_joint_profiles.forEach((item, index, array) => {
                        if (index === 0) {
                            combined_names = item.name;
                        } else {
                            combined_names = combined_names + ' + ' + item.name;
                        }
                    });
                    this.current_customer.name = combined_names;
                }
        
                return this.current_customer;
            } catch (e) {
                this.current_customer = null;
                console.log('Customer Store (getCustomerSimple) failed:' + e.response.data.message);
            }
        },
        async getCommitment(is_refresh = false,customer_id = null) {

						if(_gHlp.isEmpty(customer_id)){
							customer_id = this.current_customer.customer_id
						}

            let params = {
                credit_report_cust_id: customer_id
            }
            if(is_refresh){
                params = {
                    credit_report_cust_id: customer_id,
                    refresh_report: true
                }
            }
            try {
                const res = await axios.get(services.commitment +'credit-report/summary', {
                    params: params,
                    headers: getHeader()
                })
                this.current_commitment = res.data
            }catch(e){
                this.current_commitment = null
                console.log('Customer Store (getCommitment) failed:' + e.response.data.message)
            }
        },
        async getEligibility(){
            try{
                const res = await axios.get(services.customer + 'customer/' + this.current_customer.customer_id +'/dsr.eligibilities', {headers: getHeader()})
                this.current_eligibility = res.data.data
            }catch(e){
                this.current_eligibility = null
                console.log('Customer Store (getEligibility) failed:' + e.response.data.message)
            }
        },
        async getEligibilityPL(formula = 'PL'){
            try{
                const res = await axios.get(services.customer + 'customer/' + this.current_customer.customer_id +'/dsr.eligibilities?formula='+formula, {headers: getHeader()})
                this.current_eligibility_pl = res.data.data
            }catch(e){
                this.current_eligibility_pl = null
                console.log('Customer Store (getEligibilityPL) failed:' + e.response.data.message)
            }
        },
        async getPreferredBanksPersonalLoan(formula, customerID){
            try{
                const res = await axios.get(services.customer + 'customer/' + customerID + '/dsr.eligibilities?formula='+formula, {headers: getHeader()})
                this.current_eligibility_pl = res.data.data
            }catch(e){
                this.current_eligibility_pl = null
                console.log('Customer Store (getEligibilityPL) failed:' + e.response.data.message)
            }
        },

        async generateDSR(customer_id = null){
            this.loading_dsr = true
            try{
								if(_gHlp.isEmpty(customer_id)) {
									customer_id = this.current_customer.customer_id
								}
                const res = await axios.get(services.customer + 'customer/' + customer_id +'/dsr.generate', {headers: getHeader()})
                this.current_customer = res.data.data
                this.loading_dsr = false
            }catch(e){
                this.loading_dsr = false
                console.log('Customer Store (generateDSR) failed:' + e.response.data.message)
                throw e
            }
        },
				async generateAppFormLink(){
					axios.post(
						services.customer + 'customer/' + this.current_customer.customer_id + '/esign-appfrm-generate',{},{ headers: getHeader()})
						.then(res => { 
							this.current_customer = res.data.data;
							_gNotif.notifySuccess('<b>Customer : ' + res.data.data.name + '</b> - Successfully Generate Application Link.');
						})
						.catch(e => {
							_gNotif.errorFunction(e);
						});
				},
        async getCustomerStatusTable(){
            try{
                const response = await axios.get(services.customer + 'customer/statuses', { headers: getHeader() })
                this.customer_statuses = response.data.data
                return this.customer_statuses
            }catch(e){
                console.log(e)
            }
        },
        // Add pagination/filtering to reduce data size
        async getCustomerCount(params = null) {
            try {
                // Add limit parameter to reduce response size
                const limitedParams = {
                    ...params,
                    limit: 100, // Limit initial load
                    page: 1
                }
                
                const res = await axios.get(services.customer + 'customer.count', {
                    params: limitedParams,
                    headers: getHeader()
                })
                
                // Store only essential data initially
                if(useAuthStore().viewable_customer_ids.length === 0) {
                    useAuthStore().$patch((state) => {
                        // Store only first batch
                        state.viewable_customer_ids = res.data.data.customer_ids?.slice(0, 100) || []
                        state.viewable_customer_nrics = res.data.data.customer_nrics?.slice(0, 100) || []
                    })
                }
                return res
            } catch(e) {
                console.log('Customer Store (getCustomerCount) failed:' + e.response?.data?.message)
                throw e
            }
        },
				async getCustomerMessageBundleKey(id,alt_bundle_key){
										var params = {
						message_group_bundle_key: alt_bundle_key,
					}
					try {
						const res = await axios.put(services.customer + 'customers/' + id, params, { headers: getHeader() });
						return res.data.data.message_group_bundle_key
					} catch (e) {
						// this.errorFunction(e)
						console.log('createMessageBundleKeyInCustomer() failed:' + e)
						return alt_bundle_key
					}
				},
				async getUserCanAccess(id){
					try {
						const res = await axios.get(services.customer + 'get-user-can-access-list/' + id, { headers: getHeader() });
						return res.data.data
					} catch (e) {
						// this.errorFunction(e)
						console.log('getUserCanAccess failed:' + e)
						return []
					}
        },
				saveAllTaxDeduction(customer_id,tax_deduction,deductions){
					if(_gHlp.isEmpty(customer_id)) return null;
					try {
						const total = deductions.reduce((acc, rental) => {
							const amount = parseFloat(rental.amount);
									if (isNaN(amount)) {
											return acc;
									}
									return acc + amount;
							}, 0);
							const totalOthrDeductions = parseFloat(total.toFixed(2));
							let deductionList = [];
							if(!_gHlp.isEmpty(deductions)){
								deductionList =	deductions.map(itm=>{ 
									itm.is_consolidate = itm.is_consolidate ? 1 : 0;
									return itm;
								})
							}

							let params = { 
									deductions: deductionList,
									tax_deduction: tax_deduction,
									total_other_deduction: totalOthrDeductions
							}

						axios.post(services.customer + 'customer/'+customer_id+'/income/tax_deductions', params, { headers: getHeader()})
							.then(res => { 
								return res
							})
							.catch(error => {
								_gNotif.errorFunction(error);
								return null
							})	
					} catch (e) {
						return null
					}
				},
        async updateCustomerAdvisoryStat(customer_id, status_id) {
          try {
            await axios.put(services.customer + 'customer/' + customer_id + '/loan_advisory_status/' + status_id, {}, { headers: getHeader() });
            _gNotif.notifySuccess('<b>Customer Loan Advisory Status - Successfully Updated.')
          } catch (e) {
            _gNotif.errorFunction(e);
          }
        },
				// async deleteTaxDeductionItems(ids) {
				// 	if (_gHlp.isEmpty(ids)) return false;
		
				// 	let axiosCalls = [];
				// 	for (let i = 0; i < ids.length; i++) {
				// 		const id = ids[i];
				// 		axiosCalls.push(axios.delete(services.commitment + 'credit-report/delete-angkasa/' + id, { headers: getHeader() }))
				// 	}
				// 	return Promise.all(axiosCalls)
				// },
				async importCustomer(formData){
					try{
						let reqHeader = getHeader();
						reqHeader['Content-Type'] = 'multipart/form-data';
						const response = await axios.post(services.customer + 'customer-import', formData, { headers: reqHeader })
						let x = response.data.data
						_gNotif.notifySuccess('<b>Customer :</b> Successfully Imported. <br> Created: '+x.created+' <br> Updated: '+x.updated+' <br> Skip Importing: '+x.failed)
						return x;
					}catch(e){
						_gNotif.errorFunction(e);
					}			
				}
    }
})